import { Route, Routes } from "react-router-dom"
import { AnnualMarketPrice } from "./annualPrice/AnnualMarketPrice"
import DailyPrice from "./dailyPrice/DailyPrice"
import { Production } from "./production/Production"
import { ProductionAndConsumption } from "./productionAndConsumption/ProductionAndConsumption"
import { AcquisitionThankYou } from "./acquisitionForm/thankYou/AcquisitionThankYou"
import { lazy } from "react"
import { WEB_LINKS } from "./links"
import { Spot } from "./spot/Spot"

const AcquisitionFormRouter = lazy(() =>
  import("./acquisitionFormNew/AcquisitionFormRouter").then((module) => ({ default: module.AcquisitionFormRouter }))
)

export function WebRouter() {
  return (
    <Routes>
      <Route path={WEB_LINKS.dailyChart} element={<DailyPrice />} />
      <Route path={WEB_LINKS.annualChartNano} element={<AnnualMarketPrice />} />
      <Route path={WEB_LINKS.dailyProdAndCons} element={<ProductionAndConsumption />} />
      <Route path={WEB_LINKS.production} element={<Production />} />
      <Route path={WEB_LINKS.spot} element={<Spot />} />
      <Route path={WEB_LINKS.acquisitionThankYou} element={<AcquisitionThankYou />} />

      <Route path={WEB_LINKS.acquisitionFormNew} element={<AcquisitionFormRouter formVariant="primary" />} />
      <Route path={WEB_LINKS.acquisitionFormNewSecond} element={<AcquisitionFormRouter formVariant="secondary" />} />
    </Routes>
  )
}
